import './Icon_Calendar_Fill.css';

function Icon_Calendar_Fill() {
  return (
    
      <div className='calendar-fill-icon-container'>
          <svg viewBox="0 0 24 24" className="calendar-fill-icon-svg">
            <path d="M8 2v4"/><path d="M16 2v4"/><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M3 10h18"/>
             </svg>
      </div>
            
  );
}

export default Icon_Calendar_Fill;

//<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chart-column-icon lucide-chart-column"><path d="M3 3v16a2 2 0 0 0 2 2h16"/><path d="M18 17V9"/><path d="M13 17V5"/><path d="M8 17v-3"/></svg>